import { Reveal, Eyebrow } from "./Reveal";
import OrbitalRange from "./OrbitalRange";

/* Owner-declared product range. Entries with a matching catalogue family link
   to it; the rest go to the enquiry form so the desk can confirm availability. */
const RANGE = [
    { name: "Underground Cables — LT 1.1 kV", to: "/family/aluminium-armoured-power" },
    { name: "HT Cables 11 kV to 33 kV", to: "/family/ht-11kv-ug-cables" },
    { name: "Building Wires FR & FRLS", to: "/family/house-building-wires" },
    { name: "Industrial Flexible Cables", to: "/family/flexible-welding-cables" },
    { name: "Submersible Cables", to: "/family/submersible-cables" },
    { name: "Telephone Cables" },
    { name: "Jelly Filled Telephone Cables" },
    { name: "Co-axial Cables" },
    { name: "LAN Cables" },
    { name: "Speaker Cables" },
    { name: "Welding Cables", to: "/family/flexible-welding-cables" },
    { name: "Rubber Cables" },
    { name: "Solar AC/DC Cables", to: "/family/solar-pv-cables" },
    { name: "Steel Braided Cables" },
    { name: "Industrial Braided Cables" },
    { name: "LV Power Cables", to: "/family/lt-power-cables" },
    { name: "LV Control Cables", to: "/family/control-cables" },
    { name: "MV Power Cables" },
    { name: "EHV Power Cables" },
    { name: "LT Aerial Bunched Cables" },
    { name: "MV Aerial Bunched Cables" },
    { name: "Fire Survival Cables" },
    { name: "Overhead Conductors" },
    { name: "Railway Signalling Cables" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");
// slug retained for stable test ids inside OrbitalRange

export default function Categories() {
    return (
        <section id="categories" className="relative range-section-bg py-20 lg:py-28 border-y border-white/5" data-testid="categories-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
                    <Reveal>
                        <div className="flex items-center gap-3 mb-5">
                            <Eyebrow>01 — Product Range</Eyebrow>
                            <span className="flex items-center gap-2.5 rounded-full border border-copper/40 bg-copper/10 px-3.5 py-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-copper">
                                <span className="range-pulse" />
                                24 ranges
                            </span>
                        </div>
                        <h2 className="font-display font-bold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl text-ink">
                            Every conductor,
                            <br />
                            under <em className="text-copper">one roof.</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="md:max-w-sm">
                        <p className="text-mist leading-relaxed">
                            From house wires to EHV power cables — {RANGE.length} ranges stocked and sourced,
                            one warehouse, dispatch timelines confirmed on every quotation.
                        </p>
                    </Reveal>
                </div>

                <Reveal>
                    <OrbitalRange range={RANGE} />
                </Reveal>
            </div>
        </section>
    );
}
